const env = (key, defaultValue = null) => process.env[key] || defaultValue;

const config = {
    apiUrl: env('REACT_APP_API_URL', 'http://127.0.0.1:3001')
};

module.exports = config;
